module.exports = __webpack_public_path__ + "img/compact.b436f061.png";